import { useQueries, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import api from "services/api";

import { Page } from "v2/components";
import { IDetails, IResponse } from "./TemplateMovementsExport.types";
import { TemplateMovementsExportView } from "./TemplateMovementsExport.View";
import { getContractDisplayName } from "v2/utils/getContractDisplayName";
import { ExportHistory } from "../Movimentacao/ExportHistory/Tables";


export function TemplateMovementsExport() {
  const { workspaceId, templateId } = useParams() as { workspaceId: string; templateId: string; };

  const [details, movements] = useQueries({
    queries: [
      {
        queryKey: ["pageDetail", workspaceId],
        queryFn: () => api.get<{ data: IDetails }>(`/v2/workspaces/${workspaceId}/get-details`),
        select: (data: any) => data?.data?.data as IDetails,
      },
      {
        queryKey: ["movements-export", workspaceId, templateId],
        queryFn: () => api.get<{ data: IResponse }>(`/v2/workspaces/${workspaceId}/templates/${templateId}/movements-export`),
        select: (data: any) => data?.data?.data as IResponse,
        // refetchInterval: 5000,
      },
    ],
  });

  const isLoading = (!details.isFetched && details.isFetching) || (!movements.isFetched && movements.isFetching);
  const isError = (!details.isFetched && details.isError) || (!movements.isFetched && movements.isError);

  const detailsData = details.data;
  const movementsData = movements.data;

  return (
    <>
      {isLoading && <div>Loading...</div>}
      {isError && <div>Error...</div>}
      {detailsData && movementsData && (
        <Page title={getContractDisplayName(detailsData)} backRoute={`/v2/workspaces/${detailsData.id}`}>
          <Page.Tab name="Atividades">
            <TemplateMovementsExportView data={movementsData} productType={detailsData.product.productType} />
          </Page.Tab>
          <Page.Tab name="Histórico" disabled />
          <Page.Tab name="Contrato" disabled />
          <Page.Tab name="Tabelas">
            <ExportHistory />
          </Page.Tab>
        </Page>
      )}
    </>
  );
}
